import { CSSProperties, EventHandler, FC } from 'react';

import './ClickableArea.scss';

interface IClickableAreaProps {
    'data-testid'?: string;
    className?: string;
    onClick?: EventHandler<any>;
    tabIndex?: number;
    style?: CSSProperties;
}

const ClickableArea: FC<IClickableAreaProps> = ({
    'data-testid': dataTestId,
    className = '',
    onClick,
    tabIndex = -1,
    children,
    style,
}) => {
    return (
        <div
            data-testid={dataTestId}
            className={`sp-clickable-area ${className}`.trim()}
            role="button"
            tabIndex={tabIndex}
            onKeyDown={onClick}
            onClick={onClick}
            style={style}
        >
            {children}
        </div>
    );
};

export default ClickableArea;
